import axios from 'axios'

const http = axios.create({
    baseURL: process.env.REACT_APP_API_BASEURL
})

export async function postAddExperience(title, company, description, start_date, completion_date, dispatch) {
    const AuthToken = 'Bearer '.concat(localStorage.getItem(process.env.REACT_APP_TOKENUSER));

    dispatch({ type: 'OPEN_LOADING' })
    await http.post('/professionalprofile/addexperience',
        {
            "title": title,
            "company": company,
            "description": description,
            "start_date": start_date,
            "completion_date": completion_date
        },
        {
            headers: {
                'Authorization': AuthToken
            }
        }).then(response => {
            successAddExperience(response, dispatch);
        }).catch(erro => {
            erroAddExperience(erro.response, dispatch);
        })
    dispatch({ type: 'CLOSE_LOADING' })
};

function successAddExperience(response, dispatch) {
    dispatch({
        type: 'OPEN_ALERT_DIALOG',
        title: 'Experiência',
        description: 'Dados salvos com sucesso'
    })
}

function erroAddExperience(erro, dispatch) {
    dispatch({
        type: 'OPEN_ALERT_DIALOG',
        title: 'Experiência',
        description: 'Houve um erro ao tentar salvar os dados'
    })
}